import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    email: obj?.email,
    fullName: obj?.full_name,
    role: obj?.role,
    avatar: obj?.avatar,
    isActive: obj?.is_active,
    lastLoginAt: obj?.last_login_at,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  const result = {};
  if (obj?.fullName !== undefined) result.full_name = obj.fullName;
  if (obj?.role !== undefined) result.role = obj.role;
  if (obj?.avatar !== undefined) result.avatar = obj.avatar;
  if (obj?.isActive !== undefined) result.is_active = obj.isActive;
  return result;
};

const getAll = async () => {
  const { data, error } = await supabase
    ?.from('user_profiles')
    ?.select('*')
    ?.order('created_at', { ascending: false });

  if (error) throw error;
  return data?.map(toCamelCase) || [];
};

const getById = async (id) => {
  const { data, error } = await supabase
    ?.from('user_profiles')
    ?.select('*')
    ?.eq('id', id)
    ?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const update = async (id, userData) => {
  const { data, error } = await supabase
    ?.from('user_profiles')
    ?.update(toSnakeCase(userData))
    ?.eq('id', id)
    ?.select()
    ?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const toggleActive = async (id, isActive) => {
  const { data, error } = await supabase
    ?.from('user_profiles')
    ?.update({ is_active: isActive })
    ?.eq('id', id)
    ?.select()
    ?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const inviteUser = async (email, fullName, role, password) => {
  const { data: { session } } = await supabase?.auth?.getSession();
  const accessToken = session?.access_token;
  const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

  const response = await fetch(`${supabaseUrl}/functions/v1/invite-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'apikey': supabaseAnonKey,
    },
    body: JSON.stringify({ email, fullName, role, password: password || undefined, accessToken }),
  });

  const data = await response.json();
  if (!response.ok || data?.error) {
    throw new Error(data?.error || 'Erreur lors de la création');
  }
  return data;
};

const deleteUser = async (id) => {
  const { data: { session } } = await supabase?.auth?.getSession();
  const accessToken = session?.access_token;
  const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

  const response = await fetch(`${supabaseUrl}/functions/v1/invite-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'apikey': supabaseAnonKey,
    },
    body: JSON.stringify({ action: 'delete', userId: id, accessToken }),
  });

  const data = await response.json();
  if (!response.ok || data?.error) {
    throw new Error(data?.error || 'Erreur lors de la suppression');
  }
  return data;
};

const subscribeToChanges = (callback) => {
  const channel = supabase
    ?.channel('user_profiles')
    ?.on('postgres_changes', { event: '*', schema: 'public', table: 'user_profiles' }, (payload) => {
      callback(payload);
    })
    ?.subscribe();

  return () => supabase?.removeChannel(channel);
};

export const userService = {
  getAll,
  getById,
  update,
  toggleActive,
  inviteUser,
  deleteUser,
  subscribeToChanges,
};
